import * as Actions from '../constant/ActionTypes';

const optEmailCameraReducers = (opt={responseCode: 500}, action) => {
    switch(action.type) {
        case Actions.OPT_EMAIL_CAMERA:
            return action.payload;

        default :
        return opt;
    }
}
export default optEmailCameraReducers;